import React, { useEffect, useRef, useState } from "react";
import { Brand, StoreLink } from "./SiteElements";
import LanguageSelect from "./LanguageSelect";
export default function ResponsiveMenu({ t, c, language, setLanguage }) {
  const [open, setOpen] = useState(false);
  const toggle = useRef(null);
  useEffect(() => {
    const close = (event) => {
      if (event.key === "Escape" && open) {
        setOpen(false);
        toggle.current?.focus();
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [open]);
  return (
    <header className="site-header">
      <div className="container header-layout">
        <Brand />
        <nav
          id="primary-nav"
          className={`primary-nav ${open ? "is-open" : ""}`}
          aria-label={c.navigation}
          onClick={() => setOpen(false)}
        >
          <a href="#funcionalidades">{t.features}</a>
          <a href="#how-it-works">{c.how}</a>
          <a href="#screenshots">{c.screenshots}</a>
        </nav>
        <div className="header-actions">
          <LanguageSelect
            language={language}
            setLanguage={setLanguage}
            label={c.language}
          />
          <StoreLink label={c.getShort} compact />
          <button
            ref={toggle}
            className="menu-toggle"
            type="button"
            aria-label={c.menu}
            aria-expanded={open}
            aria-controls="primary-nav"
            onClick={() => setOpen(!open)}
          >
            <span aria-hidden="true">{open ? "×" : "☰"}</span>
          </button>
        </div>
      </div>
    </header>
  );
}
